import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-alert-modal',
    templateUrl: './alert-modal.component.html',
    styleUrls: ['./alert-modal.component.scss']
})
export class AlertModalComponent {

    @Input() public title!: string;
    @Input() public message!: string;
    @Input() public showConfirmButton!: boolean;

    constructor(
        public modalRef: BsModalRef,
    ) {
    }

    public onConfirmClick(): void {
        this.modalRef.hide();
    }
}
